import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import { ProductAttributeTrees } from '@/routes/SettingsBeta/components/ProductAttributeTrees/ProductAttributeTrees';

import { type ConditionFormQuestion } from '../ConditionQuestion';

export const ProductAttributesReadOnly = ({ question }: { question: ConditionFormQuestion }) => {
  return (
    <Stack>
      <Paragraph>
        <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.product-attribute-values">
          Product attributes:
        </Trans>
        {question.productAttributeValues.length === 0 && (
          <InlineText weight="medium">
            {' '}
            <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.product-attribute-values.all">
              All
            </Trans>
          </InlineText>
        )}
      </Paragraph>

      {question.productAttributeValues.length > 0 && (
        <div style={{ paddingLeft: '1rem' }}>
          <ProductAttributeTrees productAttributeValues={question.productAttributeValues} />
        </div>
      )}
    </Stack>
  );
};
